<template>
  <div id="manager-staffExpandKey">
    <div class="table-add">
      <el-button @click="dialogFormVisible = true"
                 size="medium"
                 type="primary">新增拓展信息</el-button>
    </div>
    <div class="table-container">      
      <el-table
        :data="expandList"
        stripe      
        style="width: 100%;">
        <el-table-column
          prop="info"
          label="信息描述">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'info' : scope.row.status === 1 ? 'primary' : 'danger' ">
              {{staffStatus[scope.row.status]}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="visible"
          label="员工是否可见">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.visible ? 'success' : 'danger'">
              {{scope.row.visible ? '是' : '否'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="goToEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog 
      title="拓展信息编辑"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="dialogClosed">
      <el-form ref="addForm" label-width="100px" :rules="rules" :model="addExpandData" class="table-info">
        <el-form-item label="信息描述" prop="info">
          <el-input v-model="addExpandData.info"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="addExpandData.status">
            <el-option label="失效" :value="0"></el-option>
            <el-option label="有效，可修改" :value="1"></el-option>
            <el-option label="有效，不可修改" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工是否可见">
          <el-select v-model="addExpandData.visible">
            <el-option label="不可见" :value="0"></el-option>
            <el-option label="可见" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { staffExpandKey, staffExpandKeyAdd, staffExpandKeyUpdate } from '@/api/manager'
export default {
  name: 'manager-staffExpandKey',
  components: {
  },
  data () {
    return {
      expandList: [],
      addExpandData: {
        info: '',
        status: 1,
        visible: 1
      },
      rules: {
        info: [
          { required: true, message: '请输入信息描述', trigger: 'blur' }
        ]
      },
      staffStatus: {
        0: '失效',
        1: '有效, 可修改',
        2: '有效, 不可修改'
      },
      dialogFormVisible: false,
      isEdit: false
    };
  },
  created() {
    this.getExpandList()
  },
  methods: {
    async getExpandList() {
      const { result } = await staffExpandKey()
      this.expandList = result
    },
    async saveExpand() {
      const origin = this.addExpandData
      const params = {
        info: origin.info,
        status: Number(origin.status),
        visible: Number(origin.visible) 
      }
      const { code, msg } = await staffExpandKeyAdd(params)
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.dialogFormVisible = false;
        this.$message({
          type: 'success',
          message: msg
        })
        this.getExpandList()
      }
    },
    async updateExpand() {
      const origin = this.addExpandData
      const params = {
        id: origin.id,
        info: origin.info,
        status: Number(origin.status),
        visible: Number(origin.visible) 
      }
      const { code, msg } = await staffExpandKeyUpdate(params)
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.dialogFormVisible = false;
        this.$message({
          type: 'success',
          message: msg
        })
        this.getExpandList()
      }
    },
    save() {
      if (this.isEdit) this.updateExpand()
      else this.saveExpand()
    },
    goToEdit(data) {
      this.isEdit = true
      this.dialogFormVisible = true
      this.addExpandData = { ...data }
    },
    dialogClosed() {
      this.isEdit = false
      this.addExpandData = { info: '', status: 1, visible: 1 }
    }
  }
};
</script>

<style lang="less" scoped>
.table-container {
  width: 100%;
}
.table-add {
  margin: 7px 0 15px 0;
}
.table-container {
  padding: 8px;
  background: #fff;
  border-radius: 5px;
}
</style>
